import { gql } from "@apollo/client";

import { Company } from "graphql/types";

import { ADDRESS_FRAGMENT, AddressFragment } from "./address";

export const COMPANY_FRAGMENT = gql`
  fragment CompanyFragment on Company {
    address {
      ...AddressFragment
    }
    name
    orgNumber
    markedAsBankruptcy
    underLiquidation
    underForcedLiquidation
    deleted
  }
  ${ADDRESS_FRAGMENT}
`;

export interface CompanyFragment
  extends Pick<
    Company,
    | "address"
    | "name"
    | "orgNumber"
    | "markedAsBankruptcy"
    | "underLiquidation"
    | "underForcedLiquidation"
    | "deleted"
  > {
  address?: AddressFragment | null;
}
